<template>
    <div id="home">
        <div id="header">
            <img src="../assets/images/logo.png" alt="logo" />
            <span @click="eixt()">退出</span>
        </div>
        <div id="body">
            <router-view />
        </div>
    </div>
</template>

<script>

    export default {
        name: "Home",
        data() {
            return {
               
            };
        },
        methods: {
            eixt(){
                this.$router.push("/login");
                window.location.reload();
                window.localStorage.removeItem("token");
                window.sessionStorage.removeItem("isLogin");
                // //刷新数据
                window.sessionStorage.clear();
            }
        },
        components: {
            
        },
        watch: {
            

        },

        mounted() {
            
        },
        computed: {
            
        },
    };
</script>

<style scoped lang="less">
    #home {
        width: 100%;
        height: 100%;
    }

    #header {
        padding: 0 20px;
        background-color: #162C3A;
        overflow: hidden;
        height: 50px;
        line-height: 50px;
        img{
            float: left;
            width: 90px;
            margin-top: 10px;
        }
        span{
            color: #ffffff;
            font-size: 16rem;
            float: right;
            cursor: pointer;
        }
    }

    #body {
    }

</style>


// WEBPACK FOOTER //
// src/views/Home.vue